module.exports = __webpack_public_path__ + "img/sidebar-2.d30c9e30.jpg";